import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import { Box, Button, Menu, MenuItem, styled } from '@mui/material';

export const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => !['active', 'customWidth'].includes(prop as string),
})(({ active, customWidth }: { active: boolean; customWidth?: string }) => {
  return {
    width: customWidth ?? '10rem',
    padding: `${tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_8} ${tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_16}`,
    color: tsoPqTheme.palette.customTextColor.color_neutral_font_ft_nrtrl_enabled,
    background: active
      ? tsoPqTheme.palette.background.primary.color_primary_background_bg_prim
      : tsoPqTheme.palette.background.other.color_other_background_white,
    borderColor: tsoPqTheme.palette.customTextColor.color_neutral_font_ft_nrtrl_enabled,
    justifyContent: 'flex-start',
    textTransform: 'none',

    '&:hover': {
      cursor: 'pointer',
      background: tsoPqTheme.palette.background.neutral.color_neutral_background_bg_ntrl_accent,
    },
  };
});

export const StyledButtonContent = styled(Box)(() => {
  return {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '0.875rem minmax(0, 1fr) 0.875rem',
    alignItems: 'center',
    columnGap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_8,
  };
});

export const StyledLeadingIcon = styled(Box)(() => {
  return {
    width: '0.875rem',
    minWidth: '0.875rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };
});

export const StyledTrailingIcon = styled(StyledLeadingIcon)(() => {
  return {};
});

export const StyledButtonLabel = styled(Box)(() => {
  return {
    minWidth: 0,
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
  };
});

export const StyledMenuItem = styled(MenuItem)(() => {
  return {
    ':hover': {
      cursor: 'pointer',
      background: tsoPqTheme.palette.background.neutral.color_neutral_background_bg_ntrl_accent,
    },
    '&.Mui-selected': {
      background: tsoPqTheme.palette.background.primary.color_primary_background_bg_prim,
      '&:hover': {
        background: tsoPqTheme.palette.background.neutral.color_neutral_background_bg_ntrl_accent,
      },
    },
    '&:active': {
      background: tsoPqTheme.palette.background.primary.color_primary_background_bg_prim,
    },
  };
});

export const StyledMenu = styled(Menu, {
  shouldForwardProp: (prop) => !['active', 'customWidth'].includes(prop as string),
})(({ customWidth }: { customWidth?: string }) => {
  return {
    '& .MuiPaper-root': {
      width: customWidth ?? '10rem',
    },
  };
});
